type LogRocketRequest = {
  reqId: string
  method: string
  url: string
}

type LogRocketResponse = {
  reqId: string
  status?: number
}

const pendingRequests = new Map<string, string>()
const intentionallyCancelledRequests = new Set<string>()

const requestKey = (method: string, url: string) => {
  const normalizedUrl = url?.split(/[?#]/, 1)[0]
  return `${method?.toUpperCase()} ${normalizedUrl}`
}

export const trackLogRocketRequest = <T extends LogRocketRequest>(request: T) => {
  pendingRequests.set(request.reqId, requestKey(request.method, request.url))
  return request
}

export const markLogRocketRequestCancelled = (method: string, url: string) => {
  const cancelledKey = requestKey(method, url)

  for (const [reqId, key] of pendingRequests) {
    if (key === cancelledKey) {
      intentionallyCancelledRequests.add(reqId)
      break
    }
  }
}

export const filterLogRocketResponse = <T extends LogRocketResponse>(
  response: T,
) => {
  pendingRequests.delete(response.reqId)

  const wasIntentionallyCancelled = intentionallyCancelledRequests.delete(
    response.reqId,
  )

  if (
    wasIntentionallyCancelled &&
    (response.status === 0 || response.status == null)
  ) {
    return null
  }

  return response
}
